import { useEffect, useState } from "react";
import { useAuthContext } from "../../context/AuthContext";
import getDashboardCounts from "../../apis/getDashboardCounts";
import ComponentLoader from "../Loader/ComponentLoader";
import moment from "moment";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faDollarSign,
  faCalendar,
  faInfo,
} from "@fortawesome/free-solid-svg-icons";

const DashboardCounts = () => {
  const { userDetails } = useAuthContext();
  const user_slug = JSON.parse(userDetails).user_slug;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(false);

  useEffect(() => {
    if (user_slug !== undefined) {
      getCounts();
    }
  }, [user_slug]);

  const getCounts = () => {
    Promise.all([getDashboardCounts(user_slug)])
      .then(async ([data]) => {
        if (data?.data?.status === 0) {
          setIsLoading(false);
        } else {
          if (data?.data?.result) {
            setData(data?.data?.result);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const displayContent = () => {
    if (!data) {
      return null;
    } else {
      return (
        <Row className="g-3">
          <Col md={4} key={1}>
            <div className="card shadow-lg">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h2 className="mb-2">Total Resources</h2>
                    <span className="text-dark text-lg fw-semibold">
                      {data?.resource_count}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#FEEBC8",
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <FontAwesomeIcon icon={faUser} size="2x" />
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} key={2}>
            <div className="card shadow-lg">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h2 className="mb-2">Available Parsing Credits</h2>
                    <span className="text-success text-lg fw-semibold">
                      {data?.firm_details?.parsing_credits}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "oklch(.905 .093 164.15)",
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <FontAwesomeIcon icon={faInfo} size="2x" />
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={4} key={2}>
            <div className="card shadow-lg">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h2 className="mb-2">Renewal Date</h2>
                    <span className="text-warning text-lg fw-semibold">
                      {moment(data?.firm_details?.expiry_date).format(
                        "MMM Do, YYYY",
                      )}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "oklch(.901 .058 230.902)",
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <FontAwesomeIcon icon={faCalendar} size="2x" />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      );
    }
  };

  const checkIsLoading = () => {
    if (isLoading) {
      return <ComponentLoader />;
    } else {
      return displayContent();
    }
  };

  return <>{checkIsLoading()}</>;
};

export default DashboardCounts;
